import { render, staticRenderFns } from "./DataInputTime.vue?vue&type=template&id=2b56bc6e&scoped=true&"
import script from "./DataInputTime.vue?vue&type=script&lang=js&"
export * from "./DataInputTime.vue?vue&type=script&lang=js&"
import style0 from "./DataInputTime.vue?vue&type=style&index=0&id=2b56bc6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56bc6e",
  null
  
)

export default component.exports